var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/update/logo.svg")}})]),_c('div',[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/update/landing.svg")}})]),_c('div',{staticClass:"t-color-n1 font-weight-bold text-20"},[_vm._v("系統全面升級中"),_c('br'),_vm._v("AM 7:00恢復服務")])])
}]

export { render, staticRenderFns }